// ----------------------------------------------------------------------------
// Component: Quote Block
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_quote-block.scss';